<!-- Installation/Removal Date Header -->
<span class="air-heading">Installation/Removal Date</span>

<!-- Back to Search Link -->
<div class="back-section w-1000">
  <a routerLink="/operator-Installation-Removal" class="back-link" >Back To Search </a>
</div>

<!-- Operations Section -->
<div class="operations-section w-1000" >
  <div class="section-header">Operations</div>
  <p-table [value]="[operationData]" styleClass="p-datatable-gridlines" id="StyleTable" [tableStyle]="{'min-width': '50rem'}" 
           [scrollable]="true" [style]="{width:'100%'}" [rowHover]="true" size="small">
    <ng-template pTemplate="body" let-rowData>
      <tr>
        <td class="label">Date Entered Into System</td>
        <td class="value">{{ operationData.dateEntered }}</td>
        <td class="label">Rule 1173</td>
        <td class="value">{{ operationData.rule1173 }}</td>
      </tr>
      <tr>
        <td class="label">Operator Email</td>
        <td class="value">{{ operationData.operatorCAI }}</td>
        <td class="label">Leaking From</td>
        <td class="value">{{ operationData.leakingFrom }}</td>
      </tr>
      <tr>
        <td class="label">TLR Status</td>
        <td class="value" [ngClass]="{'red': operationData.tlrStatus  === 'Removed', 'green': operationData.tlrStatus  === 'Installed', 'blue': operationData.tlrStatus  === 'Pre-Installation'}">{{ operationData.tlrStatus }}</td>
        <td class="label">Other Leak Type specified here</td>
        <td class="value">{{ operationData.otherLeakType }}</td>
      </tr>
      <tr>
        <td class="label">Repair Type</td>
        <td class="value">{{ operationData.repairType }}</td>
        <td class="label">Operating PSI</td>
        <td class="value">{{ operationData.operatingPSI }}</td>
      </tr>
      <tr>
        <td class="label">Tag Number</td>
        <td class="value">{{ operationData.tagNumber }}</td>
        <td class="label">Operating Temp</td>
        <td class="value">{{ operationData.operatingTemp }}</td>
      </tr>
      <tr>
        <td class="label">Division</td>
        <td class="value">{{ operationData.division }}</td>
        <td class="label">Vapor/Liquid</td>
        <td class="value">{{ operationData.vaporLiquid }}</td>
      </tr>
      <tr>
        <td class="label">Section</td>
        <td class="value">{{ operationData.section }}</td>
        <td class="label">Service</td>
        <td class="value">{{ operationData.service }}</td>
      </tr>
      <tr>
        <td class="label">Plant</td>
        <td class="value">{{ operationData.plant }}</td>
        <td class="label">Other Service</td>
        <td class="value">{{ operationData.otherService }}</td>
      </tr>
      <tr>
        <td class="label">Shutdown Description</td>
        <td class="value">{{ operationData.shutdownDescription }}</td>
        <td class="label">Permanent Repair Completed</td>
        <td class="value">{{ operationData.permanentRepair }}</td>
      </tr>
      <tr>
        <td class="label">Associated Plant - Shutdown</td>
        <td class="value">{{ operationData.associatedPlant }}</td>
        <td class="label">Technical Justification</td>
        <td class="value">{{ operationData.technicalJustification == '1' ? "Performing a TLR would allow for continued safe operation and prevent the LPO associated with shutting down the unit. A Permanent repair will be implemented during the next available maintenance opportunity." : operationData.technicalJustification }}</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- Date Entry Section -->
<div class="date-entry-section w-1000">
  <div class="section-header">Enter Installation/Removal Date</div>
  
  <p-table [value]="[1]" styleClass="p-datatable-gridlines" id="StyleTable"[tableStyle]="{'min-width': '50rem'}"
           size="small" [rowHover]="true" [style]="{width:'100%'}">
    <ng-template pTemplate="body">
      <tr>
        <td class="date-label">Installation Date</td>
        <td class="date-input">
          <p-calendar [(ngModel)]="operationData.tlrInstallationDate" [showIcon]="true" 
                      dateFormat="mm/dd/yy" [style]="{width:'100%'}" [showButtonBar]="true" appendTo="body"></p-calendar>
        </td>
        <td class="date-label">Removal Date</td>
        <td class="date-input">
          <p-calendar [(ngModel)]="operationData.tlrRemovalDate" [showIcon]="true" 
                      dateFormat="mm/dd/yy" [style]="{width:'100%'}" [showButtonBar]="true" appendTo="body"></p-calendar>
        </td>
      </tr>
    </ng-template>
  </p-table>
  
  <div class="submit-section">
    <button pButton type="button" label="Submit" class="p-button-sm" (click)="onSubmit()"></button>
  </div>
</div>
